import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap'

const Footer = () => {


    return (
        <div id="footer-copyright">
            <Container fluid>
                <Row>

                        <Col sm={12} md={12} lg={12}>
                        <ListGroup horizontal>
                            <ListGroup.Item>© 2020 - Club les Piranhas du Nord - Tous droits réservés</ListGroup.Item>
                        </ListGroup>
                        </Col>
                </Row>
            </Container>
        </div >
    );
};

export default Footer;